/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PeopleProfilePhotoUrlResponse } from './peopleProfilePhotoUrlResponse';

export type GenericApiResponsePeopleProfilePhotoUrlResponseData = PeopleProfilePhotoUrlResponse | null;
